import { combineReducers } from 'redux'
import edit from './edit'
import list from './list'
import detail from './detail'
import activityList from './activityList'

export default combineReducers({
  edit,
  list,
  detail,
  activityList,
})
